import { Stack, Typography, styled } from "@mui/material"

export interface SalesTitleProps {
  title: string
  subtitle: string
}

export const SalesTitle = ({ title, subtitle }: SalesTitleProps) => (
  <Stack>
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
  </Stack>
)

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
}))
Title.defaultProps = {
  variant: "16px",
}

const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 400,
}))
Subtitle.defaultProps = {
  variant: "12px",
}
